import { __assign } from 'tslib';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrandProvider } from '@shared-ui/brand-context';
import { UitkIcon } from 'uitk-react-icons';
import { UitkEGMapsScriptLoader } from '../components/uitk-eg-map-script-loader.esm.js';

/*
  This is a HOC that loads the google/mapbox JS api before rendering the child component that is passed as a parameter.
*/
var withScriptLoader = function (childComponent, props) {
    var _a, _b;
    var scriptLoaderProps = {
        accessToken: props.accessToken,
        googleMapsId: (_a = props.mapConfig) === null || _a === void 0 ? void 0 : _a.googleMapsId,
        locale: (_b = props.mapConfig) === null || _b === void 0 ? void 0 : _b.locale,
        mapType: props.mapType,
        width: props.width,
        height: props.height,
        reloadMapProviderSDK: props.reloadMapProviderSDK
    };
    return React.createElement(UitkEGMapsScriptLoader, __assign({}, scriptLoaderProps), childComponent);
};
/*
  This function takes icon name and brand as a parameter and renders the svg into a div
*/
var buildIcon = function (iconName, className, brand) {
    var icon = (React.createElement(BrandProvider, { config: brand },
        React.createElement("div", { className: "uitk-eg-maps-icon-container" },
            React.createElement(UitkIcon, { name: iconName, className: "".concat(className, " ").concat(iconName) }))));
    var container = document.createElement('div');
    ReactDOM.render(icon, container);
    return container;
};

export { buildIcon, withScriptLoader };
